// Local translations
export const T = {
  en_GB: {
    // QL-275 — "answered", not "completed": avoids reading as the process's
    // terminal "completed" status while the flow is still being filled in.
    xOfYAnswered: (filled: number, total: number) => `${filled} of ${total} answered`,
  },
  nb_NO: {
    xOfYAnswered: (filled: number, total: number) => `${filled} av ${total} besvart`,
  },
} as const;
